import { useMutation } from '@apollo/client';
import { graphql } from 'gql.tada';
import { DeleteInvoiceMutation } from './useDeleteInvoice';
import { VoidInvoiceMutation } from './useVoidInvoice';

const RetryInvoicePaymentMutation = graphql.persisted(
  "RetryInvoicePayment",
  graphql(`
    mutation RetryInvoicePayment($input: RetryInvoicePaymentInput!) {
      retryInvoicePayment(input: $input) {
        success
        userErrors { message path }
      }
    }
  `)
);

const MarkInvoicePaidOutOfBandMutation = graphql.persisted(
  "MarkInvoicePaidOutOfBand",
  graphql(`
    mutation MarkInvoicePaidOutOfBand($input: MarkInvoicePaidOutOfBandInput!) {
      markInvoicePaidOutOfBand(input: $input) {
        success
        userErrors { message path }
      }
    }
  `)
);

export {
  DeleteInvoiceMutation,
  MarkInvoicePaidOutOfBandMutation,
  RetryInvoicePaymentMutation,
  VoidInvoiceMutation,
};

export function useDeleteInvoice() {
  return useMutation(DeleteInvoiceMutation);
}

export function useRetryInvoicePayment() {
  return useMutation(RetryInvoicePaymentMutation);
}

export function useMarkInvoicePaidOutOfBand() {
  return useMutation(MarkInvoicePaidOutOfBandMutation);
}

export function useSafeVoidInvoice() {
  return useMutation(VoidInvoiceMutation);
}
